import { render, staticRenderFns } from "./partnerShow.vue?vue&type=template&id=0c537d7f&scoped=true&"
import script from "./partnerShow.vue?vue&type=script&lang=js&"
export * from "./partnerShow.vue?vue&type=script&lang=js&"
import style0 from "./partnerShow.vue?vue&type=style&index=0&id=0c537d7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c537d7f",
  null
  
)

export default component.exports